import { render } from "./right_pie.vue?vue&type=template&id=e161bd70"
import script from "./right_pie.vue?vue&type=script&lang=js"
export * from "./right_pie.vue?vue&type=script&lang=js"
script.render = render

export default script